import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {WidgetContactChooserDataV0} from './models/widget-contact-chooser-data-v0';
import {WidgetContactChooserValueV0Dto} from './models/widget-contact-chooser-value-v0.dto';
import {IoniconsOutline} from '@pt/pt-models';

@Component({
  selector: 'pt-widget-contact-chooser-v0-edit',
  template: `
    <div *ngIf='show'>
      <div class="overflow-auto mb-2">
        <table class='table table-striped table-sm m-0'>
          <thead class='bg-secondary text-white'>
          <tr>
            <th scope='col' class='contact-chooser-col'>{{data?.header?.col1}}</th>
            <th scope='col' class='contact-chooser-col'>{{data?.header?.col2}}</th>
            <th scope='col' class='contact-chooser-col'>{{data?.header?.col3}}</th>
            <th scope='col' class='contact-chooser-col w-100'>{{data?.header?.col4}}</th>
            <th scope='col' class="latest-col"></th>
          </tr>
          </thead>
          <tbody>
          <pt-widget-contact-chooser-v0-row
            *ngFor='let value of localValue; let i = index'
            class='display-contents'
            [col1]='data.col1'
            [col2]='data.col2'
            [col3]='data.col3'
            [value]='value'
            [emailOptional]="emailOptional"
            [allValue]="localValue"
            (changeValue)='changeRowValue($event, i)'
            (deleteRow)='deleteRow(i)'>
          </pt-widget-contact-chooser-v0-row>
          </tbody>
        </table>
      </div>

      <div class="px-1">
        <span class='btn btn-sm btn-link' (click)='addRow()'>
          <pt-icon [key]='IconAdd'></pt-icon>
          {{'BUTTON.ADD' | translate}}
        </span>
      </div>

    </div>
  `,
  styles: [`
    .contact-chooser-col {
      width: 23%;
    }

    .latest-col {
      max-width: 25px;
      min-width: 25px;
    }
  `]
})
export class WidgetContactChooserV0EditComponent implements OnChanges {
  @Input() show: boolean;
  @Input() emailOptional = false;
  @Input() data: WidgetContactChooserDataV0;
  @Output() changeValue = new EventEmitter<WidgetContactChooserValueV0Dto[]>();

  localValue: WidgetContactChooserValueV0Dto[];
  IconAdd = IoniconsOutline.plus;

  changeRowValue($event: WidgetContactChooserValueV0Dto, index: number) {
    this.localValue.forEach((value: WidgetContactChooserValueV0Dto, i: number) => {
      if (i === index) {
        value.col1 = $event.col1;
        value.col2 = $event.col2;
        value.col3 = $event.col3;
        value.col4 = $event.col4;
        value.useReferentEmail = $event.useReferentEmail
      }
    });
    this.localValue = JSON.parse(JSON.stringify(this.localValue));
    this.changeValue.emit(this.localValue);
  }

  addRow() {
    this.localValue.push(
      {
        col1: null,
        col2: null,
        col3: null,
        col4: null,
        useReferentEmail: true
      });
  }

  deleteRow(index: number) {
    const newValue = [];
    this.localValue.forEach((value, i) => {
      if (i !== index) {
        newValue.push(value);
      }
    });
    this.localValue = newValue;
    this.changeValue.emit(this.localValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.localValue = this.data?.value ? JSON.parse(JSON.stringify(this.data?.value)) : [];
    }
  }

}
